export interface SafeguardingDocument {
  title: string;
  filename: string;
}

export interface SafeguardingDocumentGroup {
  heading: string;
  documents: SafeguardingDocument[];
}

export const safeguardingDocumentGroups: SafeguardingDocumentGroup[] = [
  {
    heading: 'Policies',
    documents: [
      { title: 'AETA Safeguarding Policy', filename: 'AETA-Safeguarding-Policy.pdf' },
      { title: 'Accident and Incident Policy', filename: 'Accident-and-Incident-Policy.pdf' },
      { title: 'Complaints Procedure', filename: 'Complaints-Procedure.pdf' },
      { title: 'Equality and Diversity Policy', filename: 'Equality-and-Diversity-Policy.pdf' },
      { title: 'GDPR Policy', filename: 'GDPR-Policy.pdf' },
      { title: 'Health and Safety Policy', filename: 'Health-and-Safety-Policy.pdf' },
      { title: 'Inclusion Policy', filename: 'Inclusion-Policy.pdf' },
      { title: 'Policies, Processes and Codes of Conduct (Full Document)', filename: 'Policies-Processes-and-Codes-of-Conduct.pdf' },
      { title: 'Safe Recruitment and Employing a Coach Policy', filename: 'Safe-Recruitment-and-Employing-a-Coach-Policy.pdf' },
      { title: 'Safeguarding Adults Policy', filename: 'Safeguarding-Adults-Policy.pdf' },
      { title: 'Use of Cameras and Mobile Phones Policy', filename: 'Use-of-Cameras-and-Mobile-Phones-Policy.pdf' },
      { title: 'Whistleblowing Policy', filename: 'Whistleblowing-Policy.pdf' },
    ],
  },
  {
    heading: 'Codes of Conduct',
    documents: [
      { title: 'Code of Conduct – Coaches', filename: 'Code-of-Conduct-for-Coaches.pdf' },
      { title: 'Code of Conduct – Students', filename: 'Code-of-Conduct-for-Students.pdf' },
      { title: 'Code of Conduct – Parents & Carers', filename: 'Code-of-Conduct-Parent-Carer.pdf' },
      { title: 'Code of Conduct – Umpires', filename: 'Code-of-Conduct-Umpires.pdf' },
    ],
  },
  {
    heading: 'Certificates',
    documents: [
      { title: 'NSPCC CPD Course Certificate – Richard Hutcheson', filename: 'Richard_Hutcheson_NSPCC_CPD_course_certificate.pdf' },
      { title: 'Safeguarding Annual Health Check Certificate (2025)', filename: 'Safeguarding Code Annual Health Check_Annual Health Check Certificate - Weald.pdf' },
      { title: 'Safeguarding Annual Health Check Certificate (2026)', filename: 'Safeguarding Code Annual Health Check_Annual Health Check Certificate - Weald copy.pdf' },
    ],
  },
];
